'use client';

import { useEffect } from "react";
import Link from "next/link";
import { FaChevronLeft } from "react-icons/fa";
import TestHardwareIcon from "../components/TestHardwareIcon";
import { useMouseState } from "./MouseStateContext";
import LeftButtonTest from "./components/LeftButtonTest/LeftButtonTest";
import PrecisionTest from "./components/PrecisionTest/PrecisionTest";
import ScrollTest from "./components/ScrollTest/ScrollTest";
import TestResultModal from "../components/TestResultModal";
import styles from "./mouse.module.css";

export default function MouseTest() {
    const { mouse, updateMouse, resultModal, showModal, closeModal } = useMouseState();

    useEffect(() => {
        if (!Array.isArray(mouse?.tests)) return;
        if (mouse.tests.some((test) => test?.result === "initial")) return;
        if (mouse?.messageShown) return;

        const failed = mouse.tests.some((test) => test?.result === "failed");
        const status = failed ? "failed" : "passed";

        updateMouse({ mouse: { ...mouse, messageShown: true } });
        showModal({
            title: "Mouse Results",
            status,
            body: failed
                ? "One or more mouse tests were marked failed. Reset a test to try again."
                : "All mouse tests passed. Your pointer, drag, and scroll inputs are working.",
        });
    }, [mouse?.tests, mouse?.messageShown]);

    return (
        <div className={styles.mouse}>
            <div className={styles.heading}>
                <Link href="/online-tests" className={styles.back} aria-label="Back to online tests">
                    <FaChevronLeft />
                </Link>
                <div className={styles.headingIcon}>
                    <TestHardwareIcon name="mouse" />
                </div>
                <div>
                    <h1 className={styles.title}>Mouse Test</h1>
                    <p className={styles.description}>
                        Run click-and-drag, accuracy, and scroll checks. Mark fail manually if a control
                        does not respond.
                    </p>
                </div>
            </div>

            <div className={styles.flex}>
                <div className={styles.shell}>
                    <LeftButtonTest />
                </div>
                <div className={styles.shell}>
                    <PrecisionTest />
                </div>
                <div className={styles.shell}>
                    <ScrollTest />
                </div>
            </div>

            <TestResultModal
                show={Boolean(resultModal)}
                title={resultModal?.title}
                status={resultModal?.status}
                body={resultModal?.body}
                onClose={closeModal}
            />
        </div>
    );
}
